import type { FaireProductEntity } from "../../entity_types/product";

export const p_e58ut43pcr: FaireProductEntity = {
  token: "p_e58ut43pcr",
  type: "product",
  name: "Charming Whimsy Bracelet Assortment",
  brandToken: "b_5xebl4mzo3",
  brandName: "Girl Nation | Kids Jewelry | Easter Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/8559535b33bd855b21d7cc1f93796bd39d08eef5651ca280d007e7cae95e6f52.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/affcd1303e3da4d40318ad11e9e5a13b33133b01035904b0a437e0765e240a98.jpeg",
    "https://cdn.faire.com/fastly/d738eff2092ac8ad9467bb60862cd5da89c7f78805c1d1ee2fe3c1e1e3b8b383.jpeg",
    "https://cdn.faire.com/fastly/c4d20ad6c9582372131a94f370ce08d2f58264d265a9ca5149682a39bb6f4e4e.jpeg",
    "https://cdn.faire.com/fastly/389397e090b73238dbea0d73d9818210277d8ab9fc887dd3fe5b18d695a1cf33.jpeg",
    "https://cdn.faire.com/fastly/dd4e024ffb5f8a9e5d2eae78b751734d96d4f69fa23a9a3b00d320f4e8036db0.jpeg",
    "https://cdn.faire.com/fastly/929bfc83e42a7fe54c81c43a325cb1b8c483ca984397125d18fd60504447d7ce.jpeg",
    "https://cdn.faire.com/fastly/650f3fb5987e6c3de904381c7fc6f917237bcbadf55cc1a5c21dde0280b27862.jpeg",
    "https://cdn.faire.com/fastly/46f7beb1ecdeabe46753965058c4efa7df87a77396ecb4ca81884b2a805e5387.jpeg",
  ],
  priceDollars: 7.5,
  description:
    'Whimsical charms and colorful beads make a sweet statement about some of her favorite things!  \n\nValue Assortment includes 36 bracelets and a FREE display! Reduces unit cost to $7.50, for a savings of $18.00 *Designs subject to availability. \nBracelet card/packaging measures 3" x 4.5". Display measures 8" x 8" x 19"\nHypoallergenic, Nickel and Lead Free',
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:41.134Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
